<div
  #emblaRoot
  [id]="emblaId()"
  class="embla-thumbs w-full max-w-full overflow-hidden py-2"
>
  <div class="embla-thumbs__container flex gap-2 items-center min-w-0">
    @for (slide of files(); track $index; let i = $index) {
      <div class="embla-thumbs__slide-wrapper shrink-0 relative group">
        <div
          (click)="onThumbnailClick(i)"
          [class.active]="i === index() && showCurrentSlideIndicator()"
          class="embla-thumbs__slide rounded-lg overflow-hidden border-2 border-proffeo-border cursor-pointer transition-all hover:border-proffeo-surface-off"
        >
          @if (slide.isImage()) {
            <img
              [src]="slide.previewUrl()"
              [alt]="'Thumbnail ' + (i + 1)"
              class="w-full h-full object-cover pointer-events-none"
            />
          } @else if (slide.isVideo()) {
            <video
              [src]="slide.previewUrl()"
              muted
              playsinline
              class="w-full h-full object-cover pointer-events-none"
            ></video>
            <div class="absolute inset-0 flex items-center justify-center bg-proffeo-overlay">
              <mat-icon
                fontIcon="play_circle"
                class="icon-white"
              />
            </div>
          } @else if (slide.isPdf()) {
            <div
              class="flex flex-col items-center justify-center w-full h-full bg-proffeo-surface-muted text-proffeo-text"
            >
              <mat-icon
                fontIcon="picture_as_pdf"
                class="icon-2xl icon-danger"
              />
              <p class="text-xs!">PDF</p>
            </div>
          } @else {
            <div
              class="flex flex-col items-center justify-center w-full h-full bg-proffeo-surface-muted text-proffeo-muted"
            >
              <mat-icon fontIcon="insert_drive_file" />
              <p class="text-xs!">File</p>
            </div>
          }
        </div>
        @if (allowDelete()) {
          <proffeo-ui-button
            (clicked)="onDeleteClick($event, slide)"
            variant="danger"
            fontIcon="close"
            ariaLabel="files.files-list-delete"
            class="absolute -top-2 -right-2 z-50 md:opacity-0 md:group-hover:opacity-100"
          />
        }
      </div>
    } @empty {
      <span class="text-proffeo-muted">{{ 'files.no-images-to-display' | translate }}</span>
    }
  </div>
</div>
